import App from '@/models/App'

export default class ChatPublicUser extends App {
    static get entity() {
        return 'ChatPublicUsers'
    }
    static fields() {
        return {
            id: this.attr(''),
            firstName: this.attr(''),
            middleName: this.attr(''),
            lastName: this.attr(''),
            firstNameEn: this.attr(''),
            middleNameEn: this.attr(''),
            lastNameEn: this.attr(''),
            profileImage: this.attr(''),
            email: this.attr(''),
            tel: this.attr(''),
            companyName: this.attr(''),
            companyNameEn: this.attr(''),
            companyTel: this.attr(''),
            job: this.attr(''),
            companyWebsite: this.attr(''),
            department: this.attr(''),
            fax: this.attr(''),
            description: this.attr(''),
            isPublicProfile: this.attr(false),
        }
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static find(profileId) {
        return this.query().withAllRecursive().find(profileId)
    }
    static apiConfig = {
        actions: {
            fetch(params) {
                return this.get(`/chats/public/users`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
        },
    }
}
